import React from 'react';
import { Panel } from 'reactflow';
import Style from './PropertyPanel.module.css';

const EdgePanel = ({
  edge,
  nodes,
  transformationTypes,
  selectedTransformType,
  onClose,
  onUpdateLabel,
  onUpdateTransformationType,
  onConfigureTransform,
  onRemoveEdge,
  canEdit
}) => {
  // Find the source and target node labels
  const sourceNode = nodes.find(n => n.id === edge.source);
  const targetNode = nodes.find(n => n.id === edge.target);

  return (
    <Panel position="top-right" className={Style.panel}>
      <div className={Style.header}>
        <h3 className={Style.title}>Edge Properties</h3>
        <button
          type="button"
          onClick={onClose}
          className={Style.close}
          aria-label="Close"
        >
          <i className="uil-times" aria-hidden="true" />
        </button>
      </div>
      <div className={Style.body}>
        <div>
          <label className={Style.label}>Source</label>
          <input
            value={sourceNode?.data.label || edge.source}
            className={`${Style.input} ${Style.inputSource}`}
            readOnly
          />
        </div>
        <div>
          <label className={Style.label}>Target</label>
          <input
            value={targetNode?.data.label || edge.target}
            className={`${Style.input} ${Style.inputTarget}`}
            readOnly
          />
        </div>
        <div>
          <label className={Style.label}>Mapping Name</label>
          <input
            value={edge.data?.label || edge.label || ""}
            className={Style.input}
            onChange={(e) => onUpdateLabel(e.target.value)}
            readOnly={!canEdit}
          />
        </div>
        <div>
          <label className={Style.label}>Transformation</label>
          <select
            value={edge.data?.transformationType || 'none'}
            onChange={(e) => onUpdateTransformationType(e.target.value)}
            disabled={!canEdit}
            className={Style.input}
          >
            {transformationTypes.map(type => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </select>
        </div>
        {canEdit && <div className={Style.actions}>
          <button
            type="button"
            className={`${Style.button} ${
              selectedTransformType === 'none'
                ? Style.buttonDisabled
                : Style.buttonPurple
            }`}
            onClick={onConfigureTransform}
            disabled={selectedTransformType === 'none'}
          >
            <i className="uil-setting" aria-hidden="true" />
            Configure
          </button>
          <button
            type="button"
            className={`${Style.button} ${Style.buttonDanger}`}
            onClick={onRemoveEdge}
          >
            <i className="uil-trash-alt" aria-hidden="true" />
            Remove
          </button>
        </div>}
      </div>
    </Panel>
  );
};

export default EdgePanel;
